import { DeserializeHtml } from '../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_HYPER_LINK } from './defaults';

const deserializeLinkNode = (el) => {
  if (el && el?.nodeName === 'A' && el?.href) {
    return { type: ELEMENT_HYPER_LINK, url: el.getAttribute('href') };
  }
  return undefined;
};

export const deserializeLink = (): DeserializeHtml => {
  return {
    element: [
      {
        type: 'ELEMENT_HYPER_LINK',
        deserialize: deserializeLinkNode,
      },
    ],
  };
};
